<template>
  <div
    id="our_fleet"
    class="q-px-sm"
  >
    <h2 class="q-mb-sm text-h5 text-weight-medium text-center">{{ $t('label.our_fleet') }}</h2>
    <div class="line-y" />
    <div class="flex justify-center q-col-gutter-md break-word q-my-md text-center">
      <router-link
        v-for="{ id, delivery } in $store.state.configs.configs.transport_types"
        :key="id"
        class="fleet"
        :to="{
          name: 'transfer.new',
          query: {
            transfer_type: delivery ? 'delivery' : 'route',
            transfer: {
              transport_type_ids: [id],
            },
          },
        }"
        @click.native="sendToAnalitics(id)"
      >
        <q-img
          :src="`common/transport_types/${id}_small.png`"
          :alt="$t(`transport_types.${id}.common`)"
          spinner-size="sm"
          width="80px"
        />
        <div class="q-mt-xs text-black fs-12">
          {{ $t(`transport_types.${id}.common`) }}
        </div>
      </router-link>
      <a
        class="fleet"
        :href="getTransportLink"
        target="_blank"
        @click="sendToAnalitics('cargo')"
      >
        <q-img
          src="common/transport_types/cargo_small.png"
          :alt="$t('transport_types.cargo.common')"
          spinner-size="sm"
          width="80px"
        />
        <div class="q-mt-xs text-black fs-12">
          {{ $t('transport_types.cargo.common') }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { ExtarnalLinks } from '~mixins';

export default {
  name: 'OurFleet',
  mixins: [
    ExtarnalLinks,
  ],
  methods: {
    sendToAnalitics(id) {
      if (id === 'cargo') {
        try {
          window.gtag('event', 'delivery', {
            event_category: 'type',
            event_label: 'cargo',
          });
        } catch (e) {}
      } else {
        try {
          window.gtag('event', 'calculate1', { event_action: 'calculate' });
        } catch (e) {}
        try {
          window.gtYaCounter('reachGoal', 'calculate-yandex');
        } catch (e) {}
        try {
          window.uetq = window.uetq || [];
          window.uetq.push({
            ec: 'calculate-bing1',
            ea: 'calculate-bing2',
            el: 'calculate-bing3',
            ev: 1,
          });
        } catch (e) {}
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.line-y {
  background-color: $primary;
  height: 5px;
  margin: 8px auto;
  width: 5%;
}

@media screen and (max-width: $breakpoint-xs-max) {
  .fleet {
    width: calc(100% / 3);
  }
}
</style>
